import { WorkResource } from '@/api/requests/work/types';
import { MutationTree } from 'vuex';
import { WorkState } from './types';
import { WorkMediaDeleteRequestPayload, WorkMediaResourcePayload } from '@/store/modules/work/types';

export const mutations: MutationTree<WorkState> = {
    /**
     * Add a work to the list.
     *
     * @param state
     * @param work
     */
    addWork(state, work: WorkResource) {
        state.works.push(work);
    },

    /**
     * Set the work list.
     *
     * @param state
     * @param tasks
     */
    setWorks(state, works: WorkResource[]) {
        state.works = works;
    },

    /**
     * Set selected work.
     *
     * @param state
     * @param tasks
     */
    setSelectedWork(state, work: WorkResource) {
        state.selectedWork = work;
    },

    /**
     * Add a media to a work, or update if already exists.
     *
     * @param state
     * @param workId
     * @param media
     */
    addMediaToWork(state, { workId, media }: WorkMediaResourcePayload) {
        if (!state.selectedWork) {
            return;
        }
        const index = state.selectedWork && state.selectedWork.media.length > 0
            ? state.selectedWork.media.findIndex((item) => item.id === media.id)
            : -1;
        if (index > -1) {
            state.selectedWork.media.splice(index, 1, media);
        } else {
            state.selectedWork.media.push(media);
        }
    },

    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },

    /**
     * Remove a media from a work.
     *
     * @param state
     * @param workId
     * @param mediaId
     */
    removeMediaFromWork(state, { workId, mediaId }: WorkMediaDeleteRequestPayload) {
        if (!state.selectedWork) {
            return;
        }
        const index = state.selectedWork && state.selectedWork.media.length > 0
            ? state.selectedWork.media.findIndex((item) => item.id === mediaId)
            : -1;
        if (index > -1) {
            state.selectedWork.media.splice(index, 1);
        }
    },
};
